import React from 'react';
import { Translation } from 'react-i18next';
import { Typography } from 'antd';
import Logger from '../../../../../lib/Logger';
import { pathTo } from '../../../Routes';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';

import useFetchSignedUrl from '../../../hooks/useFetchSignedUrl';
import imageLoading from './../../../assets/images/image-loading.png';
import { StateCardTag } from '../../../elements/components/Tags';

const { Paragraph, Title } = Typography;

const LearningModuleCardLarge = ({
  item,
  getSignedUrl,
  imageUrl,
  setActiveImage,
  imagePath,
  activeId,
  history,
  ...props
}) => {
  const goToModule = () => {
    history.push(
      pathTo('LearningModuleStepsScreen', {
        id: activeId,
        moduleId: item?.id,
      })
    );
  };

  useFetchSignedUrl(imagePath, imageUrl, getSignedUrl, setActiveImage);

  return (
    <Translation>
      {(t) => (
        <>
          <div className='learning-module-card' key={item.id}>
            <div className='learning-module-card-image-container'>
              <img
                className='cursor-pointer'
                onClick={goToModule}
                alt='media-module'
                src={imageUrl ?? imageLoading}
              />
            </div>
            <div className='learning-module-card-content'>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Title
                  level={5}
                  style={{ margin: 0 }}
                  className='cursor-pointer'
                  onClick={goToModule}
                >
                  {item.title}
                </Title>
                <StateCardTag value={item.state_current} />
              </div>

              <Paragraph ellipsis={{ rows: 2 }}>{item.description}</Paragraph>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Link
                  to={pathTo('LearningModuleStepsScreen', {
                    id: activeId,
                    moduleId: item?.id,
                  })}
                  style={{ textDecoration: 'underline' }}
                >
                  {t('learning_module_continue_module')}
                </Link>
              </div>
            </div>
          </div>
        </>
      )}
    </Translation>
  );
};

export default withRouter(LearningModuleCardLarge);

Logger.log('silly', `LearningModuleCardLarge loaded.`);
